import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppState } from '../../../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';
import { State } from '@clr/angular';
import { ReplicatedService } from './replicated.service';
import { HttpClient } from '@angular/common/http';
var $ = require('jquery');

@Component({
  selector: 'replicated-vapp',
  providers: [ReplicatedService, TranslateService],
  host: {'[class.content-container]': 'true'},
  styles: [require('./replicated-vdc.scss')],
  encapsulation: ViewEncapsulation.None,
  template: require('./replicated-vapp.html')
})

export class ReplicatedVapp {
  @Input() selectedVdc: any = null;
  private pageSize: number = 6;

  private subscription: Subscription;
  private replicatedVapps = [];
  private loading: boolean = true;
  private result: any;

  private isRestorePointsModalVisible: boolean = false;
  private restorePointModalHeader: String;
  private selectedVapp: any = {};
  private isVmsModalVisible: boolean = false;
  private vmsModalHeader: String;

  constructor(public appState: AppState, public translate: TranslateService, public http: HttpClient, public service: ReplicatedService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    if (this.selectedVdc && this.selectedVdc.id) {
      this.getReplicatedVapps(this.selectedVdc.id);
    }
  }

  refresh(state: State) {
    this.loading = true;
    if (this.selectedVdc && this.selectedVdc.id) {
      this.getReplicatedVapps(this.selectedVdc.id);
    }
  }

  ngOnChanges(changes) {
    this.loading = true;
    if (this.selectedVdc && this.selectedVdc.id) {
      this.getReplicatedVapps(this.selectedVdc.id);
    }
  }

  getReplicatedVapps(vdcId) {
    this.subscription = this.service.getReplicatedVApps(vdcId)
      .subscribe(
        result => {
          this.result = result;
          this.processData(this.result);
        },
        error => this.handleError(error, 'get replicated Vapps'),
        () => this.handleCompleted('get replicated Vapps completed')
      );
  }

  processData(res) {
    if (res) {
      this.replicatedVapps = res;
    } else {
      this.replicatedVapps = [];
    }
    this.loading = false;
  }

  onRestorePointsClick = (vapp) => {
      this.restorePointModalHeader = this.translate.instant('dpsModule.replicatedVdc.vappList.restorePoints.popupHeader') + vapp.name;
      this.selectedVapp = vapp;
      this.selectedVapp.vdcId = this.selectedVdc && this.selectedVdc.id ? this.selectedVdc.id : null;
      this.selectedVapp.vdcName = this.selectedVdc && this.selectedVdc.name ? this.selectedVdc.name : null;
      this.isRestorePointsModalVisible = true;
  };

  onRestorePointsModalClose = (emittedData) => {
    this.isRestorePointsModalVisible = false;
  };

  onVmsClick = (vapp) => {
      this.vmsModalHeader = this.translate.instant('dpsModule.replicatedVdc.vappList.vms.popupHeader') + vapp.name;
      this.selectedVapp = vapp;
      this.selectedVapp.vdcId = this.selectedVdc && this.selectedVdc.id ? this.selectedVdc.id : null;
      this.selectedVapp.vdcName = this.selectedVdc && this.selectedVdc.name ? this.selectedVdc.name : null;
      this.isVmsModalVisible = true;
  };

  onVmsModalClose = (emittedData) => {
    this.isVmsModalVisible = false;
  };

  ngOnDestroy() {
    if (this.subscription) {
        this.subscription.unsubscribe();
    }
  }

  handleError(error, msg = "") {
    this.loading = false;
    this.service.logError(error, msg);
  }

  handleCompleted(msg = "") {
    this.loading = false;
    this.service.logOperationCompleted(msg)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vapp.component.ts